import { useCallback, useEffect, useMemo, useState } from "react"
import DesktopIntro from "./Desktop"
import MobileIntro from "./Mobile"

const RealEstate = () => {

  const isMobile = useCallback(() => document.body.clientWidth < 768, [])
  const [mobile, setMobile] = useState(false)
  const onResize = () => {
    setMobile(isMobile())
  }

  useEffect(() => {
    setMobile(isMobile())
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])


  const content = useMemo(() => {
    if (mobile) {
      return <MobileIntro />
    }

    return <DesktopIntro />
  }, [mobile])


  return content
}

export default RealEstate